export const createLoginStateFactory = (state, action) => {
    return {
        ...action.payload
    }
};
